import { Controller } from "@hotwired/stimulus"

// Submits a POST request to a URL on click, then follows the redirect or
// reloads the page. Use this when you can't render a real <form> (e.g. when
// the trigger sits inside another <form> — nested <form> tags break the
// parent form, drop fields, and cause per-form CSRF mismatches).
//
// Usage:
//   <button type="button"
//           data-controller="post-action"
//           data-post-action-url-value="<%= some_path %>"
//           data-post-action-confirm-value="Are you sure?"
//           data-action="click->post-action#submit">
//     Do the thing
//   </button>
//
// Values:
//   url      — required; the URL to POST to.
//   confirm  — optional; if present, shows a confirm() dialog first.
export default class extends Controller {
  static values = {
    url:     String,
    confirm: String
  }

  async submit(event) {
    event.preventDefault()

    if (this.hasConfirmValue && this.confirmValue.length > 0) {
      if (!window.confirm(this.confirmValue)) return
    }

    const button = event.currentTarget
    button.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken(),
          "Accept":       "text/html"
        },
        credentials: "same-origin"
      })

      if (!response.ok) {
        button.disabled = false
        alert(`Request failed (${response.status}). Please reload the page and try again.`)
        return
      }

      // fetch transparently follows 3xx redirects; response.url is the final URL.
      if (response.redirected) {
        window.location.href = response.url
      } else {
        window.location.reload()
      }
    } catch (e) {
      button.disabled = false
      alert(`Request failed: ${e.message}`)
    }
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
